import MutationUtils from '@/utils/MutationUtils';

import * as types from './mutation-types';

const mutations = {
  [types.UPDATE_REVENUESPLIT]: MutationUtils.makeUpdateListStateMutation('revenueSplits'),
};

export default mutations;
